import React, { useState } from 'react';

import { Skeleton } from 'uikit/loaders';

import VideoImage from '../images/default_on_demand_cover.svg';

import styles from '../styles/videoCoverArt.module.scss';

const formatDuration = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

const VideoCoverArt = ({
  duration,
  picture,
}) => {
  const [loading, setIsLoading] = useState(true);

  return (
    <div className={styles.listItemMeta}>
      <div className={styles.duration}>
        {formatDuration(duration)}
      </div>
      <div className={styles.listItemImageContainer}>
        {loading && picture
          && <Skeleton className={styles.listItemImage} height={190} width="350px" />}
        {picture
          ? <img className={styles.listItemImage} src={picture} alt="" onLoad={() => setIsLoading(false)} />
          : <div className={styles.listItemImage}><VideoImage /></div>}
      </div>
    </div>
  );
};

export default VideoCoverArt;
